<template>
  <div v-if="item">
    <fields-list :item="item" :fields="fields" />
    <div class="save-group">
      <button class="btn btn-warning btn-icon" @click="updateItem">
        <span class="ti-save"></span>{{ "save" | setText("Сохранить") }}
      </button>
    </div>
  </div>
</template>
<script>
import { cardUpdate, cardContent, pushLang } from "@/plugins/functions";

export default {
  data: () => ({
    cardLink: "info_projects",
    cardSetLink: "info_projects",
    item: null,
    fields: [
      {
        key: "title",
        col: "col-12",
        label: "Название",
        labelKey: "name",
        isMultiLang: true,
        type: "field",
      },
      {
        key: "code",
        col: "col-12",
        label: "CODE",
        labelKey: "code",

        type: "field",
      },
    ],
  }),

  props: ["id"],
  async created() {
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    pushLang: pushLang,
    async updateItem() {
      let item = await this.cardUpdate(
        this.cardSetLink,
        this.item,
        this.fields
      );
    },
  },
};
</script>
<style>
</style>
